__turbopack_context__.v({
  "Checkbox": "EditInvestorProfileForm-module-scss-module__fy6s3W__Checkbox",
  "Icon": "EditInvestorProfileForm-module-scss-module__fy6s3W__Icon",
  "Indicator": "EditInvestorProfileForm-module-scss-module__fy6s3W__Indicator",
  "Label": "EditInvestorProfileForm-module-scss-module__fy6s3W__Label",
  "block": "EditInvestorProfileForm-module-scss-module__fy6s3W__block",
  "body": "EditInvestorProfileForm-module-scss-module__fy6s3W__body",
  "col": "EditInvestorProfileForm-module-scss-module__fy6s3W__col",
  "contactSupportLink": "EditInvestorProfileForm-module-scss-module__fy6s3W__contactSupportLink",
  "cta": "EditInvestorProfileForm-module-scss-module__fy6s3W__cta",
  "ctaBlock": "EditInvestorProfileForm-module-scss-module__fy6s3W__ctaBlock",
  "ctaIcon": "EditInvestorProfileForm-module-scss-module__fy6s3W__ctaIcon",
  "ctaLink": "EditInvestorProfileForm-module-scss-module__fy6s3W__ctaLink",
  "desc": "EditInvestorProfileForm-module-scss-module__fy6s3W__desc",
  "divider": "EditInvestorProfileForm-module-scss-module__fy6s3W__divider",
  "fundAvatar": "EditInvestorProfileForm-module-scss-module__fy6s3W__fundAvatar",
  "fundDetails": "EditInvestorProfileForm-module-scss-module__fy6s3W__fundDetails",
  "fundInfo": "EditInvestorProfileForm-module-scss-module__fy6s3W__fundInfo",
  "fundInfoBox": "EditInvestorProfileForm-module-scss-module__fy6s3W__fundInfoBox",
  "fundName": "EditInvestorProfileForm-module-scss-module__fy6s3W__fundName",
  "infoContent": "EditInvestorProfileForm-module-scss-module__fy6s3W__infoContent",
  "infoIcon": "EditInvestorProfileForm-module-scss-module__fy6s3W__infoIcon",
  "infoLink": "EditInvestorProfileForm-module-scss-module__fy6s3W__infoLink",
  "infoSection": "EditInvestorProfileForm-module-scss-module__fy6s3W__infoSection",
  "infoSectionContent": "EditInvestorProfileForm-module-scss-module__fy6s3W__infoSectionContent",
  "infoSectionLabel": "EditInvestorProfileForm-module-scss-module__fy6s3W__infoSectionLabel",
  "infoText": "EditInvestorProfileForm-module-scss-module__fy6s3W__infoText",
  "infoTitle": "EditInvestorProfileForm-module-scss-module__fy6s3W__infoTitle",
  "link": "EditInvestorProfileForm-module-scss-module__fy6s3W__link",
  "linkIcon": "EditInvestorProfileForm-module-scss-module__fy6s3W__linkIcon",
  "noAccessActionText": "EditInvestorProfileForm-module-scss-module__fy6s3W__noAccessActionText",
  "noAccessActions": "EditInvestorProfileForm-module-scss-module__fy6s3W__noAccessActions",
  "noAccessContent": "EditInvestorProfileForm-module-scss-module__fy6s3W__noAccessContent",
  "noAccessDescription": "EditInvestorProfileForm-module-scss-module__fy6s3W__noAccessDescription",
  "noAccessIcon": "EditInvestorProfileForm-module-scss-module__fy6s3W__noAccessIcon",
  "noAccessInfoBox": "EditInvestorProfileForm-module-scss-module__fy6s3W__noAccessInfoBox",
  "noAccessTitle": "EditInvestorProfileForm-module-scss-module__fy6s3W__noAccessTitle",
  "optImg": "EditInvestorProfileForm-module-scss-module__fy6s3W__optImg",
  "primary": "EditInvestorProfileForm-module-scss-module__fy6s3W__primary",
  "removeButton": "EditInvestorProfileForm-module-scss-module__fy6s3W__removeButton",
  "row": "EditInvestorProfileForm-module-scss-module__fy6s3W__row",
  "secondaryLabel": "EditInvestorProfileForm-module-scss-module__fy6s3W__secondaryLabel",
  "sectionHeader": "EditInvestorProfileForm-module-scss-module__fy6s3W__sectionHeader",
  "switchDesc": "EditInvestorProfileForm-module-scss-module__fy6s3W__switchDesc",
  "teamLogo": "EditInvestorProfileForm-module-scss-module__fy6s3W__teamLogo",
  "teamOption": "EditInvestorProfileForm-module-scss-module__fy6s3W__teamOption",
});
